import classNames from 'classnames';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import useInputAndDropdownTheme from 'hb-react/shared/hooks/theme/useInputAndDropdownTheme';

import style from './index.module.scss';

const OtherAmount = ({
  campaign,
  otherAmount,
  name,
  biggerDisplay,
  onChange,
  onBlur,
}) => {
  const inputAndDropdownTheme = useInputAndDropdownTheme();

  return (
    <div
      className={classNames('inline-block input-with-icon', style.component, {
        [style['component--bigger']]: biggerDisplay,
      })}
    >
      <i
        className={style.currency}
        style={{
          color: inputAndDropdownTheme.color,
        }}
      >
        {campaign.currency.symbol}
      </i>
      <div className="input flush">
        <StyledInput
          type="number"
          name={name}
          value={otherAmount}
          className={style.input}
          min="0"
          step="any"
          placeholder={__('Amount')}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
};

OtherAmount.propTypes = {
  campaign: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  biggerDisplay: PropTypes.bool,
  otherAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

OtherAmount.defaultProps = {
  biggerDisplay: false,
};

export default OtherAmount;

// Reuse input theming for this custom input
const StyledInput = styled.input`
  ${({ theme }) => css`
    background: ${theme.input.bg} !important;
    color: ${theme.input.color} !important;
    border-color: ${theme.input.borderColor} !important;

    ::placeholder {
      color: ${theme.input.placeholder} !important;
    }
  `}
`;
